export default __webpack_public_path__ + "static/media/ic_south_korea.4231bb22.svg";